import { render, staticRenderFns } from "./AppLoaderAdmin.vue?vue&type=template&id=978e6a9a"
import script from "./AppLoaderAdmin.vue?vue&type=script&lang=js"
export * from "./AppLoaderAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports